<template>
  <div class="min-h-screen bg-base-100 flex flex-col">
    <MainHeader :isMinimal="true" />

    <router-view />

    <Footer v-if="!hideFooter" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import Footer from "@/components/Footer.vue";
import MainHeader from "@/components/headers/MainHeader.vue";

const route = useRoute();

// ✅ New: computed from route.meta
const hideFooter = computed(() => route.meta.hideFooter === true);
</script>
